<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <div
    v-if="plpAdvertisingEnabled && withPaymentAdvertisement"
    class="product-card-klarna-osm flex items-end"
  >
    <PaymentAdvertisement
      :base-price
      :spot="PaymentAdvertisingSpot.PRODUCT_CARD"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { PaymentAdvertisingSpot } from '../../types/PaymentAdvertisingSpot'
import PaymentAdvertisement from '../PaymentAdvertisement/PaymentAdvertisement.vue'

defineProps<{
  basePrice: Price
  withPaymentAdvertisement: boolean
}>()

const experiments = useExperiments()
const { market } = useMarketplace()
const plpAdvertisingEnabled = computed(() => {
  return (
    market.countryCode === MarketCountryCode.GB &&
    experiments['experiment.plpPaymentAdvertising'] === 'withAdvertising'
  )
})
</script>

<style scoped>
.product-card-klarna-osm :deep(klarna-placement::part(osm-badge)) {
  width: 36px;
}

.product-card-klarna-osm :deep(klarna-placement::part(osm-badge-container)) {
  width: 36px;
  margin-right: -8px;
}

.product-card-klarna-osm :deep(klarna-placement::part(osm-message)),
.product-card-klarna-osm :deep(klarna-placement::part(osm-legal)),
.product-card-klarna-osm :deep(klarna-placement::part(osm-cta)) {
  font-size: 12px;
  line-height: 16px;
}
</style>
